module.exports = __webpack_public_path__ + "img/605.7cf6ccb0.jpg";